<template>
  <div class="app-wrap">
    <SplashScreen @done="splashDone = true" />
    <Transition name="app-fade">
      <div v-show="splashDone" class="app-layout">
        <TheHeader />
        <main class="app-layout__main">
          <router-view />
        </main>
        <TheFooter />
        <OrderButton />
        <FortuneFab />
      </div>
    </Transition>
    <OrderModal />
    <QuestionModal />
    <ReviewModal />
    <TermsModal />
    <CookieBanner />
    <Toast />
    <DiscountToast :splash-done="splashDone" />
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import TheHeader from '@/components/TheHeader.vue'
import SplashScreen from '@/components/SplashScreen.vue'
import OrderModal from '@/components/OrderModal.vue'
import QuestionModal from '@/components/QuestionModal.vue'
import ReviewModal from '@/components/ReviewModal.vue'
import CookieBanner from '@/components/CookieBanner.vue'
import OrderButton from '@/components/OrderButton.vue'
import FortuneFab from '@/components/FortuneFab.vue'
import Toast from '@/components/Toast.vue'
import DiscountToast from '@/components/DiscountToast.vue'
import TheFooter from '@/components/TheFooter.vue'
import TermsModal from '@/components/TermsModal.vue'

export default {
  name: 'App',
  components: { TheHeader, SplashScreen, OrderModal, QuestionModal, ReviewModal, CookieBanner, OrderButton, FortuneFab, Toast, DiscountToast, TheFooter, TermsModal },
  setup() {
    const splashDone = ref(false)

    onMounted(() => {
      // Проверяем, что это мобильное устройство или планшет
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) || 
                       (window.matchMedia && (window.matchMedia('(max-width: 1024px)').matches))
      
      if (!isMobile) return

      // Блокируем зум по двойному тапу
      let lastTouchEnd = 0
      document.addEventListener('touchend', (e) => {
        const now = Date.now()
        if (now - lastTouchEnd <= 300) {
          e.preventDefault()
        }
        lastTouchEnd = now
      }, { passive: false })

      // Блокируем pinch zoom (мультитач)
      document.addEventListener('touchmove', (e) => {
        if (e.touches.length > 1) {
          e.preventDefault()
        }
      }, { passive: false })

      // Блокируем gesture события (iOS)
      document.addEventListener('gesturestart', (e) => {
        e.preventDefault()
      })
      document.addEventListener('gesturechange', (e) => {
        e.preventDefault()
      })
      document.addEventListener('gestureend', (e) => {
        e.preventDefault()
      })
    })

    return { splashDone }
  }
}
</script>

<style lang="scss">
@import "./styles/_fonts.scss";
@import "./styles/_variables.scss";

html {
  -webkit-text-size-adjust: 100%;
  -webkit-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: transparent;
}

html, body {
  margin: 0;
  padding: 0;
  touch-action: manipulation;
}

@media (max-width: 1024px) {
  html, body {
    touch-action: pan-x pan-y;
    -ms-touch-action: pan-x pan-y;
  }
}

#app {
  font-family: 'Arimo', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
  color: $color-text;
  background: $color-bg;
}

.app-wrap {
  min-height: 100vh;
}

.app-layout {
  min-height: 100vh;
  display: flex;
  overflow-x: hidden;
  flex-direction: column;

  &__main {
    flex: 1;
  }
}

.app-fade-enter-active {
  transition: opacity 0.8s ease-out;
}

.app-fade-enter-from {
  opacity: 0;
}
</style>
